import React, {Component} from 'react';

export class Footer extends Component {
    render(){
        return(
            <div className="footer">
                <p>Disclaimer: This user interface was only built to incorporate a GoLang server with Xero's API. It is unofficial and currently in progress.</p>
            </div>
        )
    }
}